import { Outlet } from "react-router";
import Header from "../../../../../component/layout/header";
import useNav from "../../../../../script/tabingNavArray";

const AgentsLayout = () => {
  const navList = useNav();
  let { AgentsBottomHeader, OperationsTopHeader } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={AgentsBottomHeader} topTabs={OperationsTopHeader} />
      <Outlet />
    </div>
  );
};

export default AgentsLayout;
